import React from "react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Zoom from "@mui/material/Zoom";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import PropTypes from "prop-types";

interface Props {
  children: React.ReactElement;
}

function HideOnScroll({ children }: Props) {
  const trigger = useScrollTrigger({ threshold: 0 });
  return (
    <Zoom in={trigger}>
      {children}
    </Zoom>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "fixed",
    bottom: "12px",
    right: "15px",
    width: "46.7px",
    height: "87.5px",
  },
}));

export const ScrollToTop = (props) => {
  const { children } = props;
  const classes = useStyles();
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 300,
  });

  const handleClick = (event) => {
    window.scrollTo({ top: 0, behavior: `smooth` })
  };

  return (
    // <HideOnScroll>
    // </HideOnScroll>

      <Zoom in={trigger}>
        <div onClick={handleClick} role="presentation" className={classes.root}>
          {children}
        </div>
      </Zoom>

  );
};

ScrollToTop.propTypes = {
  children: PropTypes.element.isRequired,
};
